import "@fontsource/clicker-script/index.css"
import "@fontsource/merriweather-sans/400.css"

